import Parse from 'html-react-parser';

function BMP20260(props) {
    function circleGenA() {
        let newCircle = "";
        for (let i = 0; i < 119; i++) {
            let cy = (4078.9 - 17.1) / 119 * i + 34.13;
            newCircle += `<g transform="translate(0, ${cy}) rotate(${2.25 * i})" transform-origin="17.1px 17.1px">
            <circle cx="17.1" cy="17.1" r="10" stroke="none" />
            <line x1="16.9878" y1="17.1289" x2="8.98776" y2="24.1289" />
            </g>`
        }
        return newCircle;
    }

    let svgCode =
        `<svg width="34" height="4096" viewBox="0 0 34 4096" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g stroke="${props.fontColour}" stroke-width="2" fill="${props.knobColour}" >
            <circle cx="17.1" cy="17.1" r="10" stroke="none" />
            <line x1="16.9878" y1="17.1289" x2="8.98776" y2="24.1289" />
            ${circleGenA()}
            </g>
        </svg>`


    props.svgReturn(47, svgCode, "bmp00260", 64, 7680);

    const style = {
        display: props.display
    }

    return (
        <div style={style}>
            {Parse(svgCode)}
        </div>
    );
}

export default BMP20260;